import React from "react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const Credibility = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#F7F8F5] py-28 md:py-36" data-testid="home-credibility">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-7">
          <div className="w-14 h-px bg-[#19C7C1] mb-8" />
          <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-light tracking-tight text-[#061A26] leading-[1.15]">
            {t.credibility.title}
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-4 md:col-start-9 flex items-end">
          <p className="text-base text-slate-600 leading-relaxed">{t.credibility.copy}</p>
        </Reveal>
      </div>
    </section>
  );
};
